<div class="url-not-found">
  <img src="./assets/images/icons/url_not_found.svg" alt="URL Not Found." class="img-urlNotFound" />
  <h2>That page doesn't exist!</h2>
  <p>Sorry, the page you were looking for could not be found.<br />It may have been removed or your key is blocked.</p>
  <hr class="divisor" />
  <h3>
    You can
    <a
      href="mailto:am.om.businesssolutions-support@global.ntt?subject=URL%20Not%20Found&body=Hello%20Support%2C%0D%0AI'm%20trying%20to%20access%20a%20page%20that%20doesn't%20exist.%0D%0ACould%20you%20please%20help%20me%3F"
      >contact us</a
    >
    for more details about this access.
  </h3>
</div>
